import { useTranslation } from "react-i18next";
import { useAuth, type EmployeeAccessContext } from "./auth-context";
import { LanguageSwitcher } from "./LanguageSwitcher";

export function AccessStatePage({ status, access }: { status: "invited" | "disabled" | "error"; access?: EmployeeAccessContext }) {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  return <main className="auth-page"><section className="auth-card" aria-labelledby="access-title">
    <div className="auth-actions"><LanguageSwitcher /></div>
    <p className="eyebrow">{t("auth.internalOnly")}</p>
    <h1 id="access-title">{t(`auth.${status}Title`)}</h1>
    <p className="lead">{t(`auth.${status}Description`)}</p>
    {access && <p className="identity-line">{access.workEmail}</p>}
    <button className="secondary-button" type="button" onClick={() => void signOut()}>{t("auth.signOut")}</button>
  </section></main>;
}
